import React from 'react';
import MultiSelectDropdown from './MultiSelectDropdown';

// Keep filter option labels and optgroups shared with existing select controls.
export default function FilterSelect({ children, value, onChange, className, ...props }) {
  const options = [];
  let allLabel = 'All';
  const collect = (nodes, group) => React.Children.forEach(nodes, child => {
    if (!React.isValidElement(child)) return;
    if (child.type === 'option') {
      if (child.props.value === '') allLabel = child.props.children;
      else options.push({ value: child.props.value, label: child.props.children, group });
    } else collect(child.props.children, child.type === 'optgroup' ? child.props.label : group);
  });
  collect(children);
  return <MultiSelectDropdown {...props} searchable options={options} allLabel={allLabel}
    value={Array.isArray(value) ? value : value ? [value] : []}
    onChange={values => onChange({ target: { value: values } })} triggerClassName={className} />;
}
